export interface AdminSettingsLink {
  title: string
  description: string
  route: string
  permission: string
}

export const ADMIN_SETTINGS_DATA_LINKS: AdminSettingsLink[] = [
  {
    title: 'Manage Institutions',
    description: 'Configure what institutions students can select on the form.',
    route: '/settings/institutions',
    permission: 'EDIT_INSTITUTION'
  },
  {
    title: 'Restricted Subjects',
    description: 'Prevent crediting specific subjects for specific courses.',
    route: '/settings/restricted-subjects',
    permission: 'VIEW_RESTRICTED_SUBJECTS'
  },
  {
    title: 'Credit Limits',
    description: 'Configure maximum credit per course.',
    route: '/settings/credit-limits',
    permission: 'VIEW_CREDIT_LIMIT'
  },
  {
    title: 'Subject Contacts',
    description: 'Change who gets contacted for each subject.',
    route: '/settings/subject-contacts',
    permission: 'VIEW_COORDINATOR_OVERRIDE'
  },
  {
    title: 'Data Exports',
    description: 'Export administration data into spreadsheets.',
    route: '/settings/exports',
    permission: 'VIEW_CONFIG'
  }
]

export const ADMIN_SETTINGS_MAINTENANCE_LINKS: AdminSettingsLink[] = [
  {
    title: 'Maintenance Mode',
    description: 'Prevent people from loading or submitting the form.',
    route: '/settings/maintenance-mode',
    permission: 'VIEW_CONFIG'
  },
  {
    title: 'Credit Search page settings',
    description: 'Update settings applied to the Credit Search page.',
    route: '/settings/credit-search',
    permission: 'VIEW_CONFIG'
  }
]

export const ADMIN_SETTINGS_INTEGRATION_LINKS: AdminSettingsLink[] = [
  {
    title: 'RPA',
    description: 'Check RPA-related statistics.',
    route: '/settings/rpa/stats',
    permission: 'VIEW_CONFIG'
  },
  {
    title: 'ASPO',
    description: 'Check ASPO integration status.',
    route: '/settings/pre-offer/status',
    permission: 'VIEW_CONFIG'
  },
]
